export default __webpack_public_path__ + "static/media/ecological-strategy-msk.94a3421a.png";